export const SUBSCRIPTION_EVENT = {
  ACCESS_SUBSCRIPTION_PAGE: "Access Subscription Page",
  ACCESS_SUBSCRIPTION_DETAILS_PAGE: "Access Subscription Details Page",
  INTERACTION_WITH_SUBSCRIPTION_ANALYTIC: "Interaction With Subscription Analytic",
  EDIT_SUBSCRIPTION: "Edit Subscription",
};
